import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Dashboard from './Dashboard';
import FranchisesList from './Franchises/FranchisesList';
import AddFranchise from './Franchises/AddFranchise';
import EditFranchise from './Franchises/EditFranchise';
import EditCompany  from './settings/EditCompany';
import EditSalesSetup  from './settings/EditSalesSetup';
import EditFinanceSetup  from './settings/EditFinanceSetup';
import EditPurchaseSetup  from './settings/EditPurchaseSetup';
import EditInventorySetup  from './settings/EditInventorySetup';
import EditGeneralSetup   from './settings/EditGeneralSetup';
import VendorList   from './Vendor/VendorList';
import AddVendor    from './Vendor/AddVendor';
import EditVendor     from './Vendor/EditVendor';
import PriceList     from './Price/PriceList';
import AddPriceList      from './Price/AddPriceList';
import EditPriceList       from './Price/EditPriceList';
import PartyPurcheshList        from './PartyPurchesh/PartyPurcheshList';
import AddPartyPurchesh        from './PartyPurchesh/AddPartyPurchesh';
import EditPartyPurchesh        from './PartyPurchesh/EditPartyPurchesh';
import BrandWiseList         from './BrandWise/BrandWiseList';
import AddBrandWise         from './BrandWise/AddBrandWise';
import EditBrandWise          from './BrandWise/EditBrandWise';
import BrandPartyDiscountList  from './BrandPartyDiscount/BrandPartyDiscountList';
import AddBrandPartyDiscount   from './BrandPartyDiscount/AddBrandPartyDiscount';
import EditBrandPartyDiscount    from './BrandPartyDiscount/EditBrandPartyDiscount';
import PurchaseRequisitionList     from './PurchaseRequisition/PurchaseRequisitionList';
import AddPurchaseRequisition      from './PurchaseRequisition/AddPurchaseRequisition';
import EditPurchaseRequisition    from './PurchaseRequisition/EditPurchaseRequisition';
import PurchaseOrderList     from './PurchaseOrder/PurchaseOrderList';
import AddPurchaseOrder      from './PurchaseOrder/AddPurchaseOrder';
import EditPurchaseOrder       from './PurchaseOrder/EditPurchaseOrder';
import GoodsReceiptNoteList        from './GoodsReceiptNote/GoodsReceiptNoteList';
import AddGoodsReceiptNote         from './GoodsReceiptNote/AddGoodsReceiptNote';
import EditGoodsReceiptNote          from './GoodsReceiptNote/EditGoodsReceiptNote';
import PurchaseChannelsList           from './PurchaseChannels/PurchaseChannelsList';
import AddPurchaseChannel            from './PurchaseChannels/AddPurchaseChannel';
import EditPurchaseChannel             from './PurchaseChannels/EditPurchaseChannel';
import PurchaseInvoicesList              from './PurchaseInvoices/PurchaseInvoicesList';
import AddPurchaseInvoice               from './PurchaseInvoices/AddPurchaseInvoice';
import EditPurchaseInvoice                from './PurchaseInvoices/EditPurchaseInvoice';
import PatientMasterList   from './patiente_master/PatientMasterList';
import AddPatient   from './patiente_master/AddPatient';
import EditPatient   from './patiente_master/EditPatient';
import CouponList   from './coupon/CouponList';
import AddCoupon   from './coupon/AddCoupon';
import EditCoupon   from './coupon/EditCoupon';
import CounterList   from './counter/CounterList';
import AddCounter  from './counter/AddCounter';
import EditCounter   from './counter/EditCounter';
import TenderTypeList   from './tendertypes/TenderTypeList';
import AddTenderType   from './tendertypes/AddTenderType';
import EditTenderType   from './tendertypes/EditTenderType';
import LoyaltyCardList   from './LoyaltyCard/LoyaltyCardList';
import AddLoyaltyCard    from './LoyaltyCard/AddLoyaltyCard';
import EditLoyaltyCard    from './LoyaltyCard/EditLoyaltyCard';
import PromotionsList     from './Promotions/PromotionsList';
import AddPromotion      from './Promotions/AddPromotion';
import EditPromotion      from './Promotions/EditPromotion';
import POSOrderListPage       from './POSOrder/POSOrderListPage';
import POSOrderAddPage        from './POSOrder/POSOrderAddPage';
import POSOrderEditPage        from './POSOrder/POSOrderEditPage';
import TenderSettlementList               from './TenderSettlement/TenderSettlementList';
import AddTenderSettlement              from './TenderSettlement/AddTenderSettlement';
import EditTenderSettlement               from './TenderSettlement/EditTenderSettlement';
import AlterationOrdersList     from './AlterationOrders/AlterationOrdersList';
import AddAlterationOrders     from './AlterationOrders/AddAlterationOrders';
import EditAlterationOrders     from './AlterationOrders/EditAlterationOrders';
import Daystartcloselist               from './Daystartclose/Daystartcloselist';
import AddDayStartClose                from './Daystartclose/AddDayStartClose';
import EditDayStartClose                 from './Daystartclose/EditDayStartClose';
import ItemWeighmentsList   from './ItemWeighments/ItemWeighmentsList';
import AddItemWeighments   from './ItemWeighments/AddItemWeighments';
import EditItemWeighments   from './ItemWeighments/EditItemWeighments';
import PatientReceiptPaymentsList                 from './PatientReceiptPayments/PatientReceiptPaymentsList';
import AddPatientReceiptPayments from './PatientReceiptPayments/AddPatientReceiptPayments';
import EditPatientReceiptPayments from './PatientReceiptPayments/EditPatientReceiptPayments';
import PosAlterationDeliveriesList   from './PosAlterationDeliveries/PosAlterationDeliveriesList';
import AddPosAlterationDeliveries     from './PosAlterationDeliveries/AddPosAlterationDeliveries';
import EditPosAlterationDeliveries     from './PosAlterationDeliveries/EditPosAlterationDeliveries';
import ProcessPosOrdersList     from './ProcessPosOrders/ProcessPosOrdersList';
import AddProcessPosOrder      from './ProcessPosOrders/AddProcessPosOrder';
import EditProcessPosOrder     from './ProcessPosOrders/EditProcessPosOrder';
import SchemaEvolutionsListPage     from './SchemaEvolutions/SchemaEvolutionsListPage';
import AddSchemaEvolution      from './SchemaEvolutions/AddSchemaEvolution';
import EditSchemaEvolution       from './SchemaEvolutions/EditSchemaEvolution';
import PurchaseReturnsList       from './PurchaseReturns/PurchaseReturnsList';
import AddPurchaseReturns       from './PurchaseReturns/AddPurchaseReturns';
import EditPurchaseReturn        from './PurchaseReturns/EditPurchaseReturn';



function App() {
  return (
   <Router>
      <Routes>
        <Route path="/" element={<><Dashboard /></>} />
        <Route path="/FranchisesList" element={<><FranchisesList /></>} />
        <Route path="/AddFranchise" element={<><AddFranchise/></>} />
        <Route path="/EditFranchise/:id" element={<><EditFranchise/></>} />
        <Route path="/EditCompany/:id" element={<><EditCompany /></>} />
        <Route path="/EditSalesSetup/:id" element={<><EditSalesSetup /></>} />
        <Route path="/EditFinanceSetup/:id" element={<><EditFinanceSetup /></>} />
        <Route path="/EditPurchaseSetup/:id" element={<><EditPurchaseSetup /></>} />
        <Route path="/EditInventorySetup/:id" element={<><EditInventorySetup /></>} />
        <Route path="/EditGeneralSetup/:id" element={<><EditGeneralSetup  /></>} />
        <Route path="/VendorList" element={<><VendorList/></>} />
        <Route path="/AddVendor" element={<><AddVendor/></>} />
        <Route path="/EditVendor/:id" element={<><EditVendor/></>} />
        <Route path="/PriceList" element={<><PriceList/></>} />
        <Route path="/AddPriceList" element={<><AddPriceList/></>} />
        <Route path="/EditPriceList/:id" element={<><EditPriceList/></>} />
        <Route path="/PartyPurcheshList" element={<><PartyPurcheshList/></>} />
        <Route path="/AddPartyPurchesh" element={<><AddPartyPurchesh/></>} />
        <Route path="/EditPartyPurchesh/:id" element={<><EditPartyPurchesh/></>} />
        <Route path="/BrandWiseList" element={<><BrandWiseList/></>} />
        <Route path="/AddBrandWise" element={<><AddBrandWise/></>} />
        <Route path="/EditBrandWise/:id" element={<><EditBrandWise/></>} />
        <Route path="/BrandPartyDiscountList" element={<><BrandPartyDiscountList/></>} />
        <Route path="/AddBrandPartyDiscount" element={<><AddBrandPartyDiscount/></>} />
        <Route path="/EditBrandPartyDiscount/:id" element={<><EditBrandPartyDiscount/></>} />
        <Route path="/PurchaseRequisitionList" element={<><PurchaseRequisitionList/></>} />
        <Route path="/AddPurchaseRequisition" element={<><AddPurchaseRequisition/></>} />
        <Route path="/EditPurchaseRequisition/:id" element={<><EditPurchaseRequisition/></>} />
        <Route path="/PurchaseOrderList" element={<><PurchaseOrderList/></>} />
        <Route path="/AddPurchaseOrder" element={<><AddPurchaseOrder/></>} />
        <Route path="/EditPurchaseOrder/:id" element={<><EditPurchaseOrder/></>} />
        <Route path="/GoodsReceiptNoteList" element={<><GoodsReceiptNoteList/></>} />
        <Route path="/AddGoodsReceiptNote" element={<><AddGoodsReceiptNote/></>} />
        <Route path="/EditGoodsReceiptNote/:id" element={<><EditGoodsReceiptNote/></>} />
        <Route path="/PurchaseChannelsList" element={<><PurchaseChannelsList/></>} />
        <Route path="/AddPurchaseChannel" element={<><AddPurchaseChannel/></>} />
        <Route path="/EditPurchaseChannel/:id" element={<><EditPurchaseChannel/></>} />
        <Route path="/PurchaseInvoicesList" element={<><PurchaseInvoicesList/></>} />
        <Route path="/AddPurchaseInvoice" element={<><AddPurchaseInvoice/></>} />
        <Route path="/EditPurchaseInvoice/:id" element={<><EditPurchaseInvoice/></>} />
        <Route path="/PatientMasterList" element={<><PatientMasterList/></>} />
        <Route path="/AddPatient" element={<><AddPatient/></>} />
        <Route path="/EditPatient/:id" element={<><EditPatient /></>} />
        <Route path="/CouponList" element={<><CouponList /></>} />
        <Route path="/AddCoupon" element={<><AddCoupon /></>} />
        <Route path="/EditCoupon/:id" element={<><EditCoupon /></>} />
        <Route path="/CounterList" element={<><CounterList /></>} />
        <Route path="/AddCounter" element={<><AddCounter /></>} />
        <Route path="/EditCounter/:id" element={<><EditCounter /></>} />
        <Route path="/TenderTypeList" element={<><TenderTypeList /></>} />
        <Route path="/AddTenderType" element={<><AddTenderType /></>} />
        <Route path="/EditTenderType/:id" element={<><EditTenderType /></>} />
        <Route path="/LoyaltyCardList" element={<><LoyaltyCardList /></>} />
        <Route path="/AddLoyaltyCard" element={<><AddLoyaltyCard /></>} />
        <Route path="/EditLoyaltyCard/:id" element={<><EditLoyaltyCard /></>} />
        <Route path="/PromotionsList" element={<><PromotionsList  /></>} />
        <Route path="/AddPromotion" element={<><AddPromotion   /></>} />
        <Route path="/EditPromotion/:id" element={<><EditPromotion/></>} />
        <Route path="/POSOrderListPage" element={<><POSOrderListPage /></>} />
        <Route path="/POSOrderAddPage" element={<><POSOrderAddPage /></>} />
        <Route path="/POSOrderEditPage/:id" element={<><POSOrderEditPage  /></>} />
        <Route path="/TenderSettlementList" element={<><TenderSettlementList/></>} />
        <Route path="/AddTenderSettlement" element={<><AddTenderSettlement/></>} />
        <Route path="/EditTenderSettlement/:id" element={<><EditTenderSettlement/></>} />
        <Route path="/AlterationOrdersList" element={<><AlterationOrdersList/></>} />
        <Route path="/AddAlterationOrders" element={<><AddAlterationOrders/></>} />
        <Route path="/EditAlterationOrders/:id" element={<><EditAlterationOrders/></>} />
        <Route path="/Daystartcloselist" element={<><Daystartcloselist/></>} />
        <Route path="/AddDayStartClose" element={<><AddDayStartClose/></>} />
        <Route path="/EditDayStartClose/:id" element={<><EditDayStartClose/></>} />
        <Route path="/ItemWeighmentsList" element={<><ItemWeighmentsList/></>} />
        <Route path="/AddItemWeighments" element={<><AddItemWeighments/></>} />
        <Route path="/EditItemWeighments/:id" element={<><EditItemWeighments/></>} />
        <Route path="/PatientReceiptPaymentsList" element={<><PatientReceiptPaymentsList/></>} />
        <Route path="/AddPatientReceiptPayments" element={<><AddPatientReceiptPayments/></>} />
        <Route path="/EditPatientReceiptPayments/:id" element={<><EditPatientReceiptPayments/></>} />
        <Route path="/PosAlterationDeliveriesList" element={<><PosAlterationDeliveriesList/></>} />
        <Route path="/AddPosAlterationDeliveries" element={<><AddPosAlterationDeliveries/></>} />
        <Route path="/EditPosAlterationDeliveries/:id" element={<><EditPosAlterationDeliveries/></>} />
        <Route path="/ProcessPosOrdersList" element={<><ProcessPosOrdersList/></>} />
        <Route path="/AddProcessPosOrder" element={<><AddProcessPosOrder/></>} />
        <Route path="/EditProcessPosOrder/:id" element={<><EditProcessPosOrder/></>} />
        <Route path="/SchemaEvolutionsListPage" element={<><SchemaEvolutionsListPage/></>} />
        <Route path="/AddSchemaEvolution" element={<><AddSchemaEvolution/></>} />
        <Route path="/EditSchemaEvolution/:id" element={<><EditSchemaEvolution/></>} />
        <Route path="/PurchaseReturnsList" element={<><PurchaseReturnsList/></>} />
        <Route path="/AddPurchaseReturns" element={<><AddPurchaseReturns/></>} />
        <Route path="/EditPurchaseReturn/:id" element={<><EditPurchaseReturn/></>} />

</Routes>
</Router>
  );
}

export default App;
